import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatNumber, getCurrencySymbol } from '@/lib/format';
import { useGetPurchaseOrderTotals } from '@/services/apis/queries/purchase-order/use-get-purchase-order-totals';
export function PurchaseOrderMainTotals({
  purchaseOrderId,
}: {
  purchaseOrderId: string;
}) {
  const { t, i18n } = useTranslation('purchaseOrder');
  const locale = i18n.language ?? 'en';
  const { data: purchaseOrderTotals } =
    useGetPurchaseOrderTotals(purchaseOrderId);
  const displayCurrency = ` ${getCurrencySymbol(purchaseOrderTotals?.currency ?? 'USD')}`;
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('cardTotals')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className='flex flex-col'>
          <div className='flex items-center justify-between gap-2'>
            <span className='text-muted-foreground text-sm'>
              {t('totalPrice')}
            </span>
            <span className='font-medium'>
              {formatNumber(purchaseOrderTotals?.totalPrice ?? 0, {
                locale,
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}{' '}
              {displayCurrency}
            </span>
          </div>
          <div className='flex items-center justify-between gap-2'>
            <span className='text-muted-foreground text-sm'>
              {t('totalReferences')}
            </span>
            <span className='font-medium'>
              {purchaseOrderTotals?.totalReferences}
            </span>
          </div>
          <div className='flex items-center justify-between gap-2'>
            <span className='text-muted-foreground text-sm'>
              {t('totalPackages')}
            </span>
            <span className='font-medium'>
              {purchaseOrderTotals?.totalPackages}
            </span>
          </div>
          <div className='flex items-center justify-between gap-2'>
            <span className='text-muted-foreground text-sm'>
              {t('totalCBM')}
            </span>
            <span className='font-medium'>
              {formatNumber(purchaseOrderTotals?.totalCBM ?? 0, {
                locale,
                minimumFractionDigits: 0,
                maximumFractionDigits: 3,
              })}{' '}
              m³
            </span>
          </div>
          <div className='flex items-center justify-between gap-2'>
            <span className='text-muted-foreground text-sm'>
              {t('totalContainers')}
            </span>
            <span className='font-medium'>
              {purchaseOrderTotals?.totalContainers}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
